import * as React from "react";
import { ContainerQuery, ui } from "../../../../contracts";
import { CardType } from "../../../../data";
import { marketColumnsDisplayMultiview } from "../../../../constants";
import { MainHeading } from "../MainHeading";
import { GroupingDropdown } from "../GroupingDropdown";
import { HeadingNamesWrap } from "../HeadingNamesWrap";
import { HeadingTitle } from "../HeadingTitle";
import { ToggleOddsBtn } from "../ToggleOddsBtn";
export class MainContent extends React.PureComponent {
    renderGroupingDropdown() {
        return this.props.groupingFilterConfig && this.props.groupingFilterConfig.shouldShow &&
            React.createElement(GroupingDropdown, Object.assign({}, this.props.groupingFilterConfig));
    }
    renderToggleButton() {
        return this.props.toggleOddsBtn && this.props.toggleOddsBtn.shouldShow &&
            React.createElement(ToggleOddsBtn, Object.assign({}, this.props.toggleOddsBtn));
    }
    renderMarketNames(params) {
        return this.props.marketNames.length > 0 &&
            React.createElement(HeadingNamesWrap, { marketNames: this.props.marketNames, marketTemplates: this.props.marketTemplates, queryParams: params });
    }
    getKey() {
        if (this.props.filterConfig) {
            let filterValue = this.props.filterConfig.options.filter(x => x.selected);
            if (filterValue[0]) {
                return filterValue[0].value;
            }
            else {
                return this.props.filterConfig.options[0].value;
            }
        }
        return undefined;
    }
    renderHeading(renderChildren, params) {
        return React.createElement(React.Fragment, null,
            React.createElement(MainHeading, { cardType: this.props.cardType },
                this.props.filterConfig
                    ? React.createElement(ui.DropdownEmbeddable, Object.assign({ id: "ev-list-heading-dropdown", dataUat: "evlist-heading-dropdown" }, this.props.filterConfig, { key: this.getKey() }))
                    : React.createElement(HeadingTitle, { name: this.props.name, eventsCount: this.props.eventsCount }),
                this.renderMarketNames(params),
                this.renderToggleButton(),
                this.renderGroupingDropdown(),
                this.props.mbnTag &&
                    React.createElement(ui.MbnIcon, { tagNumber: this.props.mbnTag })),
            renderChildren && this.props.children);
    }
    renderHeadingWrapper(renderChildren) {
        return this.props.cardType === CardType.Multiview
            ? React.createElement(ContainerQuery, { query: marketColumnsDisplayMultiview }, (params) => this.renderHeading(renderChildren, params))
            : this.renderHeading(renderChildren);
    }
    render() {
        return React.createElement("div", { className: "rj-ev-list__content", "data-uat": "div-ev-list-content" }, this.props.shouldCollapse
            ? React.createElement(ui.InstantCollapsible, { initiallyExpanded: this.props.shouldExpand, trigger: this.renderHeadingWrapper(false), content: React.createElement(React.Fragment, null, this.props.children) })
            : this.renderHeadingWrapper(true));
    }
}
//# sourceMappingURL=MainContent.js.map